import { z } from 'zod';

export const getSalesPersonsAccessLevelsSchema = z.array(
  z.object({
    id: z.string(),
    name: z.string(),
    level: z.number(),
  })
);

export type GetSalesPersonsAccessLevelsResponse = z.infer<typeof getSalesPersonsAccessLevelsSchema>;
